import { client } from "./client/client.gen";

export interface ApiClientRuntimeOptions {
  baseUrl: string;
  getToken?: () => string | undefined | Promise<string | undefined>;
}

export function configureApiClient({ baseUrl, getToken }: ApiClientRuntimeOptions): void {
  client.setConfig({ baseUrl, throwOnError: true });

  if (getToken != null) {
    client.interceptors.request.use(async (request) => {
      const token = await getToken();
      if (token != null) {
        request.headers.set("Authorization", `Bearer ${token}`);
      }
      return request;
    });
  }
}
